'use strict';
/* ==========================================================================
   levels/map.js — the hub, NOTEBOOK style: the shop's to-do list.
   Left: Ms. Rivera + a speech bubble, and Jay's pink sticky note (his claim, "50% + 50% = FREE?"), crossed out in red
   pen once the video is stamped. Right: NB.todo — one row per lesson.json step (a new step shows up by itself): a box
   ticked in red pen once stamped, the score in pencil (Game.progress.scores[id] = {best, of}), a handwritten "next"
   arrow on the first step not done yet. A row → Game.replace(new Levels[id]()).
   On a phone held upright the rows are buttons in the portrait dock (Dock.map) and the list is only the picture.
   ========================================================================== */
(function () {
  const LIST = { x: 900, y: 170, w: 880 };
  // Ms. Rivera's line on the map (captions only; not voiced)
  const SAY = {
    hello: 'Start at the top of the list. Watch Jay try to get free shoes.',
    next: 'Next on the list: the one with the arrow.',
    done: 'Everything ticked. You can run my till now.',
  };
  const rows = () => (window.Dock ? Dock.steps() : []);

  class MapScene extends Scene {
    enter() {
      const R = rows().filter(r => r.n != null);
      this.allDone = R.every(r => r.done);
      this.say = this.allDone ? SAY.done : R.some(r => r.done) ? SAY.next : SAY.hello;
      this.stampNew = Game._justStamped; Game._justStamped = null;
      Audio.play('paper', { gain: 0.5 });
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
    }
    open(id) {
      Audio.play('pop', { gain: 0.6 });
      const C = Levels[id];
      if (typeof C === 'function') Game.replace(new C());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const all = rows(), n = parseInt(k, 10);
      if (n >= 1 && n <= all.length) this.open(all[n - 1].id);
      if (k === 'Enter') this.open((all.find(r => r.next) || all[0]).id);
    }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t0 = this.enteredAt, t = this.t, docked = UI.docked();
      NB.ground();
      NB.title('Sole Proprietor', 520, 150, { size: 64, t0: t0 + 0.1, align: 'center' });
      NB.write('sneakers since 2009 · today\'s jobs', 520, 214, { font: 'hand', size: 32, color: NB.PAL.pencil, align: 'center', t0: t0 + 0.4 });
      // Ms. Rivera + speech (the speech goes into the dock when docked)
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.2);
      Puppet.draw('rivera', 330, 1045 + (1 - rise) * 500, 560, { facing: 1, t: T, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      // Jay's claim on a sticky note; the red pen strikes it once the video is paid
      const P_ = Game.progress || {}, watched = !!(P_.stamps && P_.stamps.video);
      NB.sticky('50% + 50%\n= FREE?', 560, 760, { w: 280, rot: 0.06, t0: t0 + 0.5 });
      if (watched) { NB.strike(590, 850, 810, 900, { t0: t0 + 0.9 }); NB.note('nope: 75% off', 600, 990, -0.04, { t0: t0 + 1.1 }); }
      if (docked) Dock.map({ title: 'Sole Proprietor', say: this.say, who: (LessonHooks.speakers && LessonHooks.speakers.rivera || {}).name, open: id => this.open(id) });
      else if (t > 0.6) UI.speech(this.say, 560, 360, { side: 'left', w: 560, t0: t0 + 0.6, who: 'rivera' });
      if (this.stampNew && T >= t0 + 0.4 && !this.stampPlayed) { this.stampPlayed = true; Audio.play('scribble', { gain: 0.5 }); }
      // the list (a picture only while docked: the dock has the rows as buttons)
      NB.todo(LIST.x, LIST.y, { w: LIST.w, t0, title: 'Today:', interactive: !docked, open: id => this.open(id) });
    }
  }
  MapScene.tags = () => NB.todoRows(LIST.x, LIST.y, { w: LIST.w }).map(r => ({ id: r.id, x: r.x, y: r.y }));   // tools/integration.js clicks these

  Levels.map = MapScene;
})();
